
import { useState } from "react";
import { Tool } from "@/hooks/use-canvas-setup";

export type AppMode = "freestyle" | "guide" | "exam";

export const useCanvasState = () => {
  const [activeTool, setActiveTool] = useState<Tool>(null);
  const [brushSize, setBrushSize] = useState(5);
  const [isCanvasEmpty, setIsCanvasEmpty] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [projectTitle, setProjectTitle] = useState("Untitled Project");
  const [currentDrawingId, setCurrentDrawingId] = useState<string | null>(null);
  const [appMode, setAppMode] = useState<AppMode>("freestyle");

  return {
    activeTool,
    setActiveTool,
    brushSize,
    setBrushSize,
    isCanvasEmpty,
    setIsCanvasEmpty,
    hasInteracted,
    setHasInteracted,
    projectTitle,
    setProjectTitle,
    currentDrawingId,
    setCurrentDrawingId,
    appMode,
    setAppMode,
  };
};
